
export const OPEN_KYC = 'OPEN_KYC';
export const CLOSE_KYC = 'CLOSE_KYC';